import { nameReg } from 'utils/functions';
import * as Yup from 'yup';

export const add_store_validation_schema = Yup.object({
    name: Yup
        .string()
        .trim()
        .required('Store Name is required')
        .min(3, " Store Name must be of 3 alphabets")
        .matches(nameReg, "Please add valid name"),
})

export const add_room_validation_schema = Yup.object({
    name: Yup
        .number()
        .required('Room Number is required')
})

